import { ApplicationFormStatus } from '../../graphql';
import { ApplicationSubmissionStatus } from '../../pages/ApplicationStatus/types';
import { MAX_SYNC_STATUS_WAIT } from '../../utils';

export const getSubmissionStatus = (
  productIsInstantApproval: boolean,
  hasJointApplicant: boolean,
  time: number,
  applicationStatus?: ApplicationFormStatus,
): ApplicationSubmissionStatus => {
  switch (true) {
    // Withdrawn is terminal for every product type — surface it ahead of any product/joint gating
    // so a withdrawn application never falls through to the SUBMITTED default.
    case applicationStatus === ApplicationFormStatus.Withdrawn:
      return ApplicationSubmissionStatus.WITHDRAWN;

    // if has joint just show joint page
    case hasJointApplicant:
      return ApplicationSubmissionStatus.JOINT_INCOMPLETE;

    case productIsInstantApproval && applicationStatus === ApplicationFormStatus.Approved:
      return ApplicationSubmissionStatus.APPROVED;

    case productIsInstantApproval && applicationStatus === ApplicationFormStatus.Declined:
      return ApplicationSubmissionStatus.DECLINED;

    // if application is still fetching show fetching status
    case productIsInstantApproval && time < MAX_SYNC_STATUS_WAIT:
      return ApplicationSubmissionStatus.FETCHING;

    case productIsInstantApproval && applicationStatus === ApplicationFormStatus.Submitted:
      return ApplicationSubmissionStatus.REFERRED;

    default:
      return ApplicationSubmissionStatus.SUBMITTED;
  }
};
